<script lang="ts">
    import {onMount} from "svelte";

    export let value = '';

    onMount( () => {
        if( value !== null ){
            value = null;
		}
	})
</script>
<div class="acp-cf-value -nonvalue">

</div>